import { useState } from "react";
import SpectraNavbar from "../components/SpectraNavbar";
import Footer from "../components/Footer";
import { useUserContext } from "../contexts";
import ChangePasswordModal from "../components/ui/ChangePasswordModal";

import { Button } from "react-bootstrap";

export default function Profile() {
  const { user } = useUserContext();
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

  const handleClose = () => setShowChangePasswordModal(false);
  const handleShow = () => setShowChangePasswordModal(true);

  return (
    <div className='flex-container'>
      <SpectraNavbar />
      <div
        className='px-sm-3 px-lg-5 py-3 flex-body justify-content-center align-items-center container-fluid flex-grow-1 h-100'
        style={{ marginTop: "79px" }}
      >
        <div className='shadow card col-lg-8 col-12 bg-white p-3 border'>
          <header className='mb-4 '>
            <h5 className='mb-1'>My Profile</h5>
            <p className='text-muted fs-6'>Manage your account information</p>
          </header>
          <div className='d-flex flex-row my-3 justify-content-around align-items-center full-height px-3 gap-3'>
            <div className='d-flex gap-4 w-100 mb-3 justify-content-center'>
              <div className='card m-auto'>
                <div className='card-header h4'>Personal Information</div>
                <div className='card-body'>
                  <p>
                    <b>Name:</b> {user?.firstName} {user?.lastName}
                  </p>
                  <p>
                    <b>Email/Username:</b> {user?.email}
                  </p>
                  {/* <p>
                    <b>Role:</b>{" "}
                    {user?.role &&
                      user.role.charAt(0).toUpperCase() + user.role.slice(1)}
                  </p> */}
                  <p>
                    <b>User ID:</b> {user?.id}
                  </p>
                  <p>
                    <b>Organization:</b> {user?.customerName}
                  </p>
                  <p>
                    <b>Location(s):</b>{" "}
                    {user?.locID?.map((loc) => loc.name).join(", ")}
                  </p>
                </div>
              </div>
              {/* <div className='card full-height'>
                <div className='card-header h4'>Account Details</div>
                <div className='card-body'>
                  <p>
                    <b>Subscription Tier:</b>{" "}
                    {user?.subscriptionTier &&
                      user.subscriptionTier.charAt(0).toUpperCase() +
                        user.subscriptionTier.slice(1)}
                  </p>
                  <p>
                    <b>Reachback Service:</b>
                  </p>
                  <p>
                    <b>Warranty Information:</b>
                  </p>
                  <p>
                    <b>Pre-Ordered Test Kits Remaining:</b>
                  </p>
                  <p>
                    <b>Last Test Kit Shipment Date:</b>
                  </p>
                </div>
              </div> */}
            </div>
            <div className='d-flex flex-column gap-5 w-100'>
              <div className='m-auto'>
                <Button variant='primary' onClick={handleShow}>
                  Change Password
                </Button>
              </div>
              <h3 className='text-center'>
                More profile features coming soon!
              </h3>
            </div>
          </div>
        </div>
        <ChangePasswordModal
          show={showChangePasswordModal}
          handleClose={handleClose}
        />
      </div>
      <Footer />
    </div>
  );
}
